import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import CurrencyFormatter from '../../Utils/CurrencyFormatter';
const ConfirmPurchaseProduct = ({ product, amount }) => {
    return (_jsx("div", Object.assign({ className: 'flex flex-col pb-3 border-b border-dark-gray mb-3' }, { children: _jsxs("div", Object.assign({ className: 'flex flex-row justify-between' }, { children: [_jsx("h3", Object.assign({ className: 'tailwind-reset product-title text-dark-teal', id: `title-${product.machineName}` }, { children: product.title })), amount && (_jsx("h5", Object.assign({ className: 'tailwind-reset product-price text-dark-teal text-right', id: `price-${product.machineName}` }, { children: CurrencyFormatter(amount) })))] })) }), product.machineName));
};
ConfirmPurchaseProduct.propTypes = {
    product: PropTypes.shape({
        machineName: PropTypes.string,
        title: PropTypes.string
    }).isRequired,
    amount: PropTypes.number
};
export default ConfirmPurchaseProduct;
